import React from "react";
import BondGeneralInformationBase from "../../../../features/bonds/shared/components/BondGeneralInformationBase";
import { GENERAL_INFORMATION_CONFIG } from "../../../../features/bonds/shared/generalInformationConfig";
import { RETRIEVE_GLOBAL_DATA_ROLE_DISABLED } from "./bondRetrieveSharedPropTypes";

const VAGeneralInformation = (props) => (
  <BondGeneralInformationBase
    cfg={GENERAL_INFORMATION_CONFIG.va.retrieval}
    {...props}
  />
);

VAGeneralInformation.propTypes = RETRIEVE_GLOBAL_DATA_ROLE_DISABLED;

export default VAGeneralInformation;
